module.exports = __webpack_public_path__ + "static/media/1882.06c11ea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/1882.jpg
// module id = 939
// module chunks = 0